const WebDesign = () => {
    return (
        <div>
            <h3>Web Design</h3>
        </div>
    );
};

export default WebDesign;